import { useNewIsLoggedIn } from "src/hooks/useIsLoggedIn";
import { BrandViewBrandCover } from "src/organisms/BrandViewBrandCover";
import { AlgoliaSearchBrand, Gender } from "src/types/Algolia";
import { HeaderSkeleton } from "../BrandView.styled";
import { Promotion } from "./Promotion";

type HeaderProps = {
  brand: AlgoliaSearchBrand;
  slug: string;
  genderId: Gender;
};

function Header({ brand, genderId, slug }: HeaderProps): JSX.Element {
  const { isLoggedIn, isSessionLoading } = useNewIsLoggedIn();

  return (
    <>
      {isSessionLoading ? (
        <HeaderSkeleton />
      ) : (
        <BrandViewBrandCover
          isLoggedIn={isLoggedIn}
          brand={brand}
          isComingSoon={brand?.coming_soon}
          genderId={genderId}
          noPadding={true}
        />
      )}
      <Promotion gender={genderId as string} slug={slug} />
    </>
  );
}

export { Header };
